import React from 'react'
import { cn } from '@utils/safeTs'
import styles from './MyAccountDashboardNumber.module.sass'
import Link from 'next/link'


interface Props {
  value?: number
  label?: string
  variant?: 'default' | 'success' | 'warning' | 'danger'
  url?: string
  className?: string
}

const MyAccountDashboardNumber = (props: Props) => {

  const { 
    value,
    label,
    variant = 'default',
    url,
    className = '',
  } = props

  const classNames = cn(styles.root, styles[`root--${variant}`], className)

  return url ? (
    <Link href={url} className={classNames}>
      {typeof value !== 'undefined' && <span className={styles.value}>{value}</span>}
      {!!label && <span className={styles.label}>{label}</span>}
    </Link>
  ) : (
    <div className={classNames}>
      {typeof value !== 'undefined' && <span className={styles.value}>{value}</span>}
      {!!label && <span className={styles.label}>{label}</span>}
    </div>
  )
}

export default MyAccountDashboardNumber
